import React, { ReactNode } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { Backdrop, Box, Divider, Paper, SxProps, Theme, Typography } from '@mui/material';

import { closeSettingsPanel } from '../../../../store/actions/appActions';

type DispatchProps = ResolveThunks<typeof actionCreators>;

interface OwnProps {
  readonly children?: ReactNode;
  readonly rootSx?: SxProps<Theme>;
  readonly title?: string;
  readonly saveButtons?: ReactNode;
  readonly elevation?: number;
}

function SettingsPanelBase(props: OwnProps & DispatchProps) {
  return (
    <>
      {/* The backdrop prevents user actions that might cause settings to be modified while the settings panel is open */}
      <Backdrop open />
      <Paper
        elevation={props.elevation ?? 0}
        sx={[
          {
            zIndex: 3000,
            whiteSpace: 'nowrap',

            position: 'absolute',
            top: 0,
            bottom: 0,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
          },
          ...(Array.isArray(props.rootSx) ? props.rootSx : [props.rootSx]),
        ]}
      >
        {props.title && (
          <Box sx={{ marginTop: 2 }}>
            <Typography gutterBottom variant="h6" align="center">
              {props.title}
            </Typography>
            <Divider />
          </Box>
        )}
        <Box sx={{ overflow: 'auto', paddingTop: 3 }}>{props.children}</Box>
        <Paper sx={{ marginTop: 'auto' }} elevation={1}>
          {props.saveButtons}
        </Paper>
      </Paper>
    </>
  );
}

const actionCreators = {
  closeSettingsPanel,
};

export default connect(null, actionCreators)(SettingsPanelBase);
